// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-7187f744]:export{siteFontFamily:system-ui,sans-serif,math,ui-rounded,ui-monospce}.cover-block[data-v-7187f744]{border:2px dashed transparent}.cover-block[data-v-7187f744]:hover{border:2p dashed #7b66f7}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
